import { render, staticRenderFns } from "./AppDock.vue?vue&type=template&id=2948a866&"
import script from "./AppDock.vue?vue&type=script&lang=js&"
export * from "./AppDock.vue?vue&type=script&lang=js&"
import style0 from "./AppDock.vue?vue&type=style&index=0&id=2948a866&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports